import React from 'react';

const HeaderLogo = () => {
  return (
    <>
      <img
        // onClick={onClick}
        src="https://images.myyogateacher.com/MYT_Logo.svg"
        width="208"
        height="24"
        className="hover:opacity-60 cursor-pointer xl:flex  w-[208px] h-[24px]"
        alt="myyogateacher-logo"
      />
    </>
  );
};

export default HeaderLogo;
